import { css } from '@emotion/react';


export default $ => $.enablePrintStyles ? css`
  @media print {
    *,
    *::before,
    *::after {
      text-shadow: none !important;
      box-shadow: none !important;
    }

    a:not(.btn) {
      text-decoration: underline;
    }

    abbr[title]::after {
      content: ' (' attr(title) ')';
    }

    pre {
      white-space: pre-wrap !important;
    }
    pre,
    blockquote {
      border: ${$.borderWidth} solid ${$.gray500};
      page-break-inside: avoid;
    }

    tr,
    img {
      page-break-inside: avoid;
    }

    p,
    h2,
    h3 {
      orphans: 3;
      widows: 3;
    }

    h2,
    h3 {
      page-break-after: avoid;
    }

    @page {
      size: ${$.printPageSize};
    }
    body {
      min-width: ${$.printBodyMinWidth} !important;
    }
    .container {
      min-width: ${$.printBodyMinWidth} !important;
    }

    .navbar {
      display: none;
    }
    .badge {
      border: ${$.borderWidth} solid ${$.black};
    }

    .table {
      border-collapse: collapse !important;

      td,
      th {
        background-color: ${$.white} !important;
      }
    }

    .table-bordered {
      th,
      td {
        border: 1px solid ${$.gray100} !important;
      }
    }

    .table-dark {
      color: inherit;

      th,
      td,
      thead th,
      tbody + tbody {
        border-color: ${$.tableBorderColor};
      }
    }

    .table .thead-dark th {
      color: inherit;
      border-color: ${$.tableBorderColor};
    }
  }
` : css``;
